import React from 'react'
import type { TextPage as TextPageData } from 'api/api.types'
import { parseHtml } from 'utils/htmlParserWithCustomLinks'
import styles from './TextPage.module.scss'

type TextPageProps = {
  page: TextPageData,
}

export const TextPage: React.FC<TextPageProps> = ({ page }) => (
  <div className={styles.container}>
    <div className={styles.contentContainer}>
      <div className={styles.textContainer}>
        <div className={styles.content}>
          <h1 className={styles.title}>{page.title}</h1>
          <article className={'text-content'}>{parseHtml(page.templateVars.pageVars.content || '')}</article>
        </div>
      </div>
    </div>
  </div>
)
